import axios, { AxiosError } from 'axios';

const API_URL = process.env.REACT_APP_API_URL || 'https://cccgnv.appgsi.com/api/v1';

console.log('API URL:', API_URL);

export interface LoginResponse {
  result: boolean;
  jwt?: string;
  message?: string;
}

export interface UserData {
  jwt: string;
  username: string;
}

export const getErrorMessage = (error: any): string => {
  if (axios.isAxiosError(error)) {
    const axiosError = error as AxiosError<any>;
    if (axiosError.response) {
      if (axiosError.response.status === 401) {
        return 'Su sesión ha expirado. Por favor, vuelva a iniciar sesión.';
      }
      return axiosError.response.data?.message || 'Error en la autenticación. Por favor, intente nuevamente.';
    }
    if (axiosError.request) {
      return 'No se pudo conectar con el servidor. Por favor, verifique su conexión a internet.';
    }
  }
  return 'Error en la autenticación. Por favor, intente nuevamente.';
};

export const getAuthHeader = () => {
  const user = getCurrentUser();
  console.log('Usuario actual:', user); // Debug
  if (user && user.jwt) {
    console.log('Token encontrado:', user.jwt); // Debug
    return { Authorization: `Bearer ${user.jwt}` };
  }
  console.log('No se encontró token'); // Debug
  return {};
};

export const getCurrentUser = (): UserData | null => {
  try {
    const userStr = localStorage.getItem('user');
    console.log('Usuario en localStorage:', userStr); // Debug
    if (!userStr) return null;
    
    const user = JSON.parse(userStr);
    return user;
  } catch (error) {
    console.error('Error al obtener usuario actual:', error);
    return null;
  }
};

export const login = async (username: string, password: string): Promise<LoginResponse> => {
  try {
    console.log('Intentando login con:', { username, API_URL });
    
    const response = await axios.post(`${API_URL}/Auth/login`, {
      user: username,
      password: password
    });
    
    console.log('Respuesta del servidor:', response.data);

    if (response.data.result) {
      const userData: UserData = {
        jwt: response.data.jwt,
        username
      };
      console.log('Guardando datos de usuario:', userData); // Debug
      localStorage.setItem('user', JSON.stringify(userData));
    }
    
    return response.data;
  } catch (error) {
    console.error('Error en login:', error);
    if (axios.isAxiosError(error)) {
      const axiosError = error as AxiosError<any>;
      console.log('Detalles del error:', { 
        status: axiosError.response?.status,
        data: axiosError.response?.data,
        headers: axiosError.response?.headers
      });
    }
    throw new Error(getErrorMessage(error));
  }
};

export const logout = () => {
  try {
    localStorage.removeItem('user');
  } catch (error) {
    console.error('Error al cerrar sesión:', error);
  }
};
